<template>
  <div class="ui modal" ref="modal">
    <i class="close icon"></i>
    <div class="header">
      <i class="eye icon"></i>
      {{ $t("survey revision") }}
    </div>
    <div class="scrolling content">
      <div class="description" style="width: 100% !important">
        <!-- <h1 class="ui icon header">
          <i class="settings icon"></i>
          <div class="content">
            Account Settings
          </div>
        </h1> -->
        <div class="ui relaxed list">
          <div class="item" v-for="(rspns, ridx) in srv.response" :key="ridx">
            <i class="check middle aligned icon"></i>
            <div class="content">
              <a class="header">{{ rspns.question.prompt }}</a>
              <div class="description">{{ rspns.answer.prompt }}</div>
            </div>
          </div>
        </div>
        <!-- <pre>{{ srv }}</pre> -->
      </div>
    </div>
    <div class="actions">
      <div class="ui red icon right labeled deny button">
        <i class="remove icon"></i>
        {{ $t("close") }}
      </div>
    </div>
  </div>
</template>

<script>
import { local_api, error_toast } from "@/utils";

export default {
  name: "SurveyRevisionModalIndex",
  components: {},
  props: {},
  computed: {},
  data() {
    return {
      srv: {},
    };
  },
  methods: {
    show_modal(uuid) {
      let vm = this;

      /**
       * get template
       */
      if (uuid) {
        local_api(vm, "post", "/feedback_360/survey/do-get-revision", {
          u: uuid,
        })
          .then((r) => {
            vm.srv = r;
          })
          .catch((err) => {
            error_toast(err);
          });
      }

      window
        .jQuery(vm.$refs.modal)
        .modal({
          onVisible() {},
          onHide() {
            vm.form.form("reset");
          },
        })
        .modal("show");

      vm.form = window.jQuery(vm.$refs.form).form({
        fields: {
          name: ["empty"],
        },
      });
    },
  },
  mounted() {},
  watch: {},
  updated: function() {},
};
</script>
